import { useCallback } from "react";
import { useDropzone } from "react-dropzone";

export default function Dropzone({
  onChange,
  containerClassName,
  message,
  label,
  dropzone,
}) {
  const onDrop = useCallback(
    (acceptedFiles) => {
      // Do something with the files
      onChange(acceptedFiles);
    },
    [onChange]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    ...dropzone,
  });

  return (
    <div className={containerClassName}>
      {label && (
        <label className="text-black-200 font-semibold text-sm mb-1 block">
          {label}
        </label>
      )}
      <div
        {...getRootProps()}
        className={
          "flex justify-center items-center text-center h-32 border-2 border-dashed rounded-sm p-5 cursor-pointer text-sm transition-colors " +
          (isDragActive
            ? "bg-primary-50 border-primary-400 text-primary-700"
            : "bg-white-200 border-white-400 text-black-300 hover:border-primary-300 hover:bg-primary-50")
        }
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Lepaskan file disini</p>
        ) : (
          <p>Tarik dan lepaskan file disini, atau klik untuk memilih</p>
        )}
      </div>

      {message && (
        <span className="text-red-300 text-sm mt-1 block">{message}</span>
      )}
    </div>
  );
}
